


import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import Select from "react-select";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import { Spin } from "antd";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Filter, Search, RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import Swal from "sweetalert2";

const PayrollReports = () => {
    const { id: reportiid } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [columns, setColumns] = useState([]);

    // Filters
    const [selectedPayPeriod, setSelectedPayPeriod] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);

    // Master data
    const [branches, setBranches] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [payPeriods, setPayPeriods] = useState([]);
    const [employees, setEmployees] = useState([]);

    const [token, setToken] = useState(null);
    const [superId, setSuperId] = useState(null);

    const [pdfLoading, setPdfLoading] = useState(false);
    const [excelLoading, setExcelLoading] = useState(false);
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
    const REPORT_COLUMNS = {
        "501": [ // Salary Report
            // { title: "Badge", key: "CardId" },
            // { title: "Name", key: "UserName" },
            // { title: "Designation", key: "Designation" },
            // { title: "Dept", key: "Department" },
            // {
            //     title: "Present / Working",
            //     key: "present_working",
            //     render: (_, row) =>
            //         `${row.PresentDays ?? 0} / ${row.WorkingDays ?? row.PresentDays ?? 0}`
            // },
            // { title: "Absent", key: "AbsentDays" },
            // { title: "Leaves", key: "Leaves" },
            // { title: "Wk-Off", key: "MonWeekOffs" },
            { title: "Gross", key: "GrossSalary" },
            { title: "Basic", key: "Basic" },
            { title: "HRA", key: "Hra" },
            { title: "Convy", key: "Conveyance" },
            { title: "Med.Alw", key: "MedicalAllowance" },
            { title: "Spl.Alw", key: "SpecialAllowance" },
            { title: "OT", key: "OT" },
            { title: "Incent", key: "Incentives" },
            { title: "Earn", key: "Earnings" },
            { title: "LOP", key: "LossOfPay" },
            { title: "PF", key: "PF" },
            { title: "ESI", key: "ESI" },
            { title: "PT", key: "PT" },
            { title: "Advnce", key: "AdvancePayment" },
            { title: "Deduct", key: "Deductions" },
            { title: "NetPay", key: "NetPayble" }
        ],

        "502": [ // PF Report
            // { title: "Name", key: "AccountHoldersName" },
            // { title: "PF Account No", key: "PFAccountNo" },
            // { title: "UAN", key: "UAN" },
            { title: "Gross Wg", key: "GrossWages" },
            { title: "EPF Wg", key: "EPF_Wages" },
            { title: "EPS Wg", key: "EPS_Wages" },
            { title: "EDLI Wg", key: "EDLI_Wages" },
            { title: "EPF Contr", key: "EpfContRemitted" },
            { title: "EPS Contr", key: "EpsContRemitted" },
            { title: "NCP Days", key: "NcpDays" },
            { title: "Notes", key: "name" }
        ],

        "506": [ // Bank Statement
            { title: "Name", key: "AccountHoldersName" },
            { title: "Badge", key: "CardId" },
            { title: "Account No", key: "AccountNo" },
            { title: "Bank Name", key: "BankName" },
            { title: "Branch", key: "BankBranch" },
            { title: "IFSC Code", key: "IfscCode" },
            { title: "Net Salary", key: "NetSalary" }
        ]
    };
    const SALARY_HEADER_FIELDS = [
        { label: " Name", key: "UserName", wide: true }, 
        { label: "Badge", key: "CardId" },
        { label: "Designation", key: "Designation" },
        { label: "Department", key: "Department" },

        {
            label: "Present / Working",
            render: row =>
                `${row.PresentDays ?? 0} / ${row.WorkingDays ?? row.PresentDays ?? 0}`
        },
        { label: "Absent", key: "AbsentDays" },
        { label: "Leaves", key: "Leaves" },
        { label: "Week-Offs", key: "MonWeekOffs" }
    ];

    const PF_HEADER_FIELDS = [
        { label: " Name", key: "AccountHoldersName", wide: true },
        { label: "PF Account No", key: "PFAccountNo" },
        { label: "UAN", key: "UAN" },
        { label: "NCP Days", key: "NcpDays" }
    ];
    useEffect(() => {
        // const sid = 10228;
        const t = sessionStorage.getItem("authToken");
        const sid = sessionStorage.getItem("PayrollSuperId");
        if (t && sid) {
            setToken(t);
            setSuperId(sid);
        } else {
            navigate("/signin");
        }
    }, [navigate]);

    useEffect(() => {
        if (!token || !superId) return;

        // Branches
        fetch(`${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superId}`, {
            headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` },
        })
            .then(r => r.json())
            .then(data => data?.status && setBranches(data.ResultData || []))
            .catch(console.error);

        // Departments
        fetch(`${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superId}`, {
            headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` },
        })
            .then(r => r.json())
            .then(data => {
                if (data?.status) {
                    setDepartments(data.ResultData?.filter(d => d.IsActive) || []);
                }
            })
            .catch(console.error);

        fetch(`${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superId}`, {
            headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` },
        })
            .then(r => r.json())
            .then(data => {
                if (data?.status) {
                    setPayPeriods(data.ResultData || []);
                }
            })
            .catch(console.error);
    }, [token, superId]);

    useEffect(() => {
        if (!token || !superId) return;

        const isAdvanced = showAdvancedSearch;
        const branchId = isAdvanced && selectedBranch?.value ? selectedBranch.value : 0;
        const deptId = isAdvanced && selectedDepartment?.value ? selectedDepartment.value : 0;

        if (isAdvanced && (!branchId || !deptId)) {
            setEmployees([]);
            setSelectedEmployee(null);
            return;
        }

        const url = `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superId}&BranchId=${branchId}&DeptId=${deptId}`;

        fetch(url, {
            headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` },
        })
            .then(r => r.json())
            .then(data => {
                if (data?.status) {
                    const emps = data.ResultData || [];
                    setEmployees(emps);
                    // Clear employee selection if not in current list
                    if (selectedEmployee?.value && !emps.some(e => e.RegId === selectedEmployee.value)) {
                        setSelectedEmployee(null);
                    }
                } else {
                    setEmployees([]);
                }
            })
            .catch(err => {
                console.error(err);
                setEmployees([]);
            });
    }, [token, superId, showAdvancedSearch, selectedBranch, selectedDepartment]);

    const branchOptions = [
        { value: "", label: "Select Branches" },
        ...branches.map(b => ({ value: b.BranchId || b.branchid, label: b.Name })),
    ];

    const deptOptions = [
        { value: "", label: "Select Departments" },
        ...departments.map(d => ({ value: d.DepartmentId, label: d.Name })),
    ];

    const payPeriodOptions = [
        { value: "", label: "Select PayPeriods" },
        ...payPeriods.map(p => ({
            value: p.Id,
            label: p.Name,
        })),
    ];

    const employeeOptions = [
        { value: "", label: "Select Employees" },
        ...employees.map(emp => ({
            value: emp.RegId,
            label: emp.UserWithBadge || `${emp.UserName || emp.Name || "Employee"} (${emp.BadgeId || "N/A"})`,
        })),
    ];

    useEffect(() => {
        if (payPeriods.length > 0 && selectedPayPeriod === null) {
            const latest = payPeriods[0]; // March-2024

            setSelectedPayPeriod({
                value: latest.Id,
                label: latest.Name,
            });
        }
    }, [payPeriods, selectedPayPeriod]);

    useEffect(() => {
        setSelectedPayPeriod(null);
        setSelectedEmployee(null);
        setSelectedDepartment(null);
        setSelectedBranch(null);
        setShowAdvancedSearch(false);
        setReportData([]);
        setColumns([]);
    }, [reportiid]);

    const fetchReport = async () => {
        if (!token || !superId || !reportiid) return;
        if (!selectedPayPeriod || !selectedEmployee) {
            Swal.fire({
                icon: "warning",
                title: "Missing Details",
                text: "Please select Pay Period and Employee",
                confirmButtonText: "OK"
            });
            return;
        }
        setLoading(true);

        try {
            const params = new URLSearchParams({
                superid: superId,
                reportiid,
            });

            if (selectedPayPeriod?.value) params.append("PayperiodId", selectedPayPeriod.value);
            if (selectedEmployee?.value) params.append("RegId", selectedEmployee.value);
            if (selectedDepartment?.value) params.append("DeptId", selectedDepartment.value);
            if (selectedBranch?.value) params.append("BranchId", selectedBranch.value);

            const url = `${Payroll_API_BASE_URL}payroll/Reports/getpayrollReports?${params}`;
            const res = await fetch(url, { headers: { Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3` } });
            const result = await res.json();

            if (result?.status && result.ResultData?.length > 0) {

                const configCols = REPORT_COLUMNS[reportiid] || [];

                const dynamicCols = configCols.map(col => ({
                    title: col.title,
                    key: col.key,
                    dataIndex: col.key,
                    render: col.render
                        ? col.render
                        : (val) => val ?? "-"
                }));

                setColumns([
                    { title: "S.No", render: (_, __, idx) => idx + 1, width: 60 },
                    ...dynamicCols
                ]);

                setReportData(result.ResultData);

            } else {
                setColumns([]);
                setReportData([]);
            }
        } catch (err) {
            console.error(err);
            setReportData([]);
            setColumns([]);
        } finally {
            setLoading(false);
        }
    };

    const headerData = reportData?.[0] || null;

    // Your export functions (unchanged)
    const exportToExcel = () => {
        console.log("Excel clicked");

        if (!reportData || reportData.length === 0) {
            // alert("No data available");
            return;
        }
        setExcelLoading(true);

        try {
            const ws = XLSX.utils.json_to_sheet(reportData);
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, ws, "Report");
            XLSX.writeFile(wb, `Report_${reportiid}.xlsx`);
        } catch (err) {
            console.error("Excel Export Error:", err);
        }
        setExcelLoading(false);
    };

    const exportToPDF = () => {
        console.log("PDF clicked");

        if (!reportData || reportData.length === 0) {
            // alert("No data available");
            return;
        }
        setPdfLoading(true);

        try {
            const doc = new jsPDF({ orientation: "landscape" });

            doc.text(`Payroll Report ${reportiid}`, 14, 15);

            autoTable(doc, {
                head: [columns.map(c => c.title)],
                body: reportData.map(row =>
                    columns.map(c => (c.dataIndex ? row[c.dataIndex] : ""))
                ),
                startY: 25,
                styles: { fontSize: 8 }
            });

            doc.save(`Report_${reportiid}.pdf`);
        } catch (err) {
            console.error("PDF Export Error:", err);
        }
        setPdfLoading(false);
    };

    const REPORT_NAME_MAP = {
        "501": "Salary Report",
        "502": "PF Report",
        "503": "ESI Report",
        "506": "Salary Bank Statement",
    };
    const reportName = REPORT_NAME_MAP[reportiid] || "Payroll Report";

    // const renderReportHeader = (fields) => (
    //   <div className="card mb-3">
    //     <div className="card-body">
    //       <h5 className="mb-2 text-primary">Employee Details</h5>

    //       <div className="row fs-16">
    //         {fields.map((field, idx) => (
    //           <div className={`col-md-${field.col || 3} mb-2`} key={idx}>
    //             <span className="me-1">{field.label}</span>
    //             <span className="me-1">:</span>
    //             <span className="fw-semibold">
    //               {field.render
    //                 ? field.render(headerData)
    //                 : headerData[field.key] ?? "-"}
    //             </span>
    //           </div>
    //         ))}
    //       </div>
    //     </div>
    //   </div>
    // );

    const renderTableHeader = (fields) => {
        const rows = [];

        for (let i = 0; i < fields.length; i += 2) {
            rows.push(fields.slice(i, i + 2));
        }

        return (
            <div className="card mb-2">
                <div className="card-body py-3 px-3">

                    {/* Heading */}
                    <h5 className="mb-2 ms-1 text-primary">Employee Details</h5>

                    <div className="table-responsive px-3">
                        <table className="table table-bordered table-sm mb-0">
                            <tbody>
                                {rows.map((pair, idx) => (
                                    <tr key={idx}>
                                        {pair.map((field, i) => (
                                            <React.Fragment key={i}>
                                                <td
                                                    className="fw-semibold"
                                                    style={{
                                                        width: "15%",
                                                        padding: "6px 8px",
                                                        whiteSpace: "nowrap",
                                                        fontSize: "14px"
                                                    }}
                                                >
                                                    {field.label}
                                                </td>
                                                <td
                                                    style={{
                                                        width: field.wide ? "22%" : "15%",
                                                        padding: "6px 8px",
                                                        fontSize: "14px"
                                                    }}
                                                >
                                                    {field.render
  ? field.render(headerData)
  : headerData?.[field.key] ?? "-"}
                                                </td>
                                            </React.Fragment>
                                        ))}

                                        {pair.length === 1 && (
                                            <>
                                                <td style={{ padding: "6px 8px" }} />
                                                <td style={{ padding: "6px 8px" }} />
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        );
    };


    return (
        <>
            {(pdfLoading || excelLoading || loading) && (
                <div className="overlay-spinner">
                    <Spin size="large" tip={loading ? "Loading report..." : "Exporting..."} />
                </div>
            )}

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header d-flex justify-content-between align-items-center mb-1">
                        <div>
                            <h4>Individual {reportName} </h4>
                            <h6>Payroll Individual Report Viewer</h6>
                        </div>

                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={<Tooltip>PDF</Tooltip>}>
                                    <a onClick={exportToPDF}>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="pdf" />
                                    </a>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Excel</Tooltip>}>
                                    <a onClick={exportToExcel}>
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="excel" />
                                    </a>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={<Tooltip>Refresh</Tooltip>}>
                                    <a onClick={() => window.location.reload()}>
                                        <RotateCcw />
                                    </a>
                                </OverlayTrigger>
                            </li>
                        </ul>
                    </div>

                    <div className="card mb-2">
                        <div className="card-body">
                            <div className="row g-3 align-items-end">
                                <div className="col-lg-2 col-sm-6 col-12">
                                    <label className="form-label">Pay Period</label>
                                    <Select
                                        classNamePrefix="react-select"
                                        options={payPeriodOptions}
                                        value={selectedPayPeriod}
                                        onChange={setSelectedPayPeriod}
                                        placeholder="Select PayPeriod"
                                        isClearable
                                        isSearchable
                                    />
                                </div>
                                {showAdvancedSearch && (
                                    <>
                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label className="form-label">Branch</label>
                                            <Select
                                                classNamePrefix="react-select"
                                                options={branchOptions}
                                                value={selectedBranch}
                                                onChange={setSelectedBranch}
                                                placeholder="Select Branches"
                                                isClearable
                                                isSearchable
                                            />
                                        </div>

                                        <div className="col-lg-2 col-sm-6 col-12">
                                            <label className="form-label">Department</label>
                                            <Select
                                                classNamePrefix="react-select"
                                                options={deptOptions}
                                                value={selectedDepartment}
                                                onChange={setSelectedDepartment}
                                                placeholder="Select Departments"
                                                isClearable
                                                isSearchable
                                            />
                                        </div>
                                    </>
                                )}

                                <div className="col-lg-2 col-sm-6 col-12">
                                    <label className="form-label">Employee</label>
                                    <Select
                                        classNamePrefix="react-select"
                                        options={employeeOptions}
                                        value={selectedEmployee}
                                        onChange={setSelectedEmployee}
                                        placeholder="Select Employees"
                                        isClearable
                                        isSearchable
                                    />
                                </div>
                                <div className="col-auto d-flex align-items-center gap-2">

                                    <button
                                        className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                        style={{ width: 48, height: 38 }}
                                        onClick={() => {
                                            const newVal = !showAdvancedSearch;
                                            setShowAdvancedSearch(newVal);

                                            if (!newVal) {
                                                setSelectedBranch(null);
                                                setSelectedDepartment(null);
                                            }

                                            setSelectedEmployee(null);
                                        }}
                                        title={showAdvancedSearch ? "Hide Advanced Filters" : "Show Advanced Filters"}
                                    >
                                        {showAdvancedSearch ? <Search size={20} /> : <Filter size={20} />}
                                    </button>

                                    <button
                                        className="btn btn-primary d-flex align-items-center justify-content-center"
                                        style={{ height: 38, minWidth: 45 }}
                                        onClick={fetchReport}
                                    >
                                        <i className="fa fa-chart-bar me-1" />
                                    </button>

                                </div>

                            </div>
                        </div>
                    </div>
                    {selectedEmployee && (
                        <>
                            {loading ? (
                                <div className="card mb-2">
                                    <div className="card-body text-center py-4">
                                        <Spin size="large" />
                                    </div>
                                </div>
                            ) : (
                                headerData && (
                                    <>
                                        {reportiid === "501" && renderTableHeader(SALARY_HEADER_FIELDS)}
                                        {reportiid === "502" && renderTableHeader(PF_HEADER_FIELDS)}
                                    </>
                                )
                            )}
                        </>
                    )}

                    <div className="card table-list-card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3" style={{ padding: "2rem" }}>
                            <div className="search-set">
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive brand-table">
                                {loading ? (
                                    <div className="text-center py-5"><Spin size="large" /></div>
                                ) : columns.length === 0 ? (
                                    <div className="text-center py-5 text-muted">
                                        Select filters and click Generate to view report
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <Table
                                            columns={columns}
                                            dataSource={reportData}
                                            rowKey={(_, i) => i}
                                            pagination={{ pageSize: 15, showSizeChanger: true }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <CommonFooter />
            </div>
        </>
    );
};

export default PayrollReports;